import { Button, Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Block from "../../../components/Block";
import BlockWard from "../../../components/BlockWard";
import DeleteDialog from "../../../components/Dialog/DeleteDialog";
import { INotifierProps } from "../../../components/Notifier/Notifier";
import { Notifier } from "../../../components";
import UserBlock from "../../../components/User/UserBlock";
import User from "../../../components/User/UserBlock";
import UserListWard from "../../../components/User/UserListWard";
import { GlobalContext } from "../../../contexts";
import useUser from "../../../services/useUser";
import { useQuery } from "react-query";

function Users() {

    const { view } = useContext(GlobalContext);
    const { deleteUser, getUsersPage } = useUser();
    const [notifier, setNotifier] = useState<INotifierProps>(null);
    const [openDelete, setOpenDelete] = React.useState<{ open: boolean, valueToDelete: any }>({ open: false, valueToDelete: null });
    const [page, setPage] = useState(1);
    const currents = useQuery(['users', page], getUsersPage, {
        refetchInterval: 60000,
    })

    function handleCloseDelete(): void {
        setOpenDelete({ open: false, valueToDelete: null });
    }

    function handlePaginator(page: number) {
        setPage(page)
    }

    function handleDelete() {
        deleteUser(openDelete.valueToDelete).then(
            () => setNotifier({ open: true, severity: 'success', msg: 'Cadastro deletado com sucesso!' }),
            () => setNotifier({ open: true, severity: 'error', msg: 'Erro ao deletar cadastro.' }),
        )
        handleCloseDelete();
    }


    useEffect(() => {
        currents.refetch();
    }, [page])

    if (currents.isSuccess && currents.data.data.length) {
        // const config: = { ...getClients.data };

        if (view === "block")
            return (
                <Grid
                    container
                    gap={2}
                    padding={view === "block" ? "20px" : ""}
                    sx={{
                        overflowY: "auto",
                    }}
                >
                    <>
                        <BlockWard title="Clientes" _id="clientes">
                            {currents.data.data.map((item) => (
                                <UserBlock data={item} />
                            ))}
                        </BlockWard>
                    </>
                </Grid>
            );
        else return <>
            <Notifier
                msg={notifier?.msg}
                closeState={setNotifier}
                severity={notifier?.severity}
                open={notifier?.open}
                closeTime={notifier?.closeTime}
            />
            <UserListWard isPageable={true} setDelete={setOpenDelete} limit={currents.data.limit} total={currents.data.total} handlePaginator={handlePaginator} data={currents.data.data}></UserListWard>
            <DeleteDialog open={openDelete.open} handleClose={handleCloseDelete} onConfirmDelete={handleDelete} name="deleteDialog" ></DeleteDialog>
        </>
    }
    return <></>
}

export default Users;